import React from 'react'
import { getTranslation } from '../translations'

function Field({ label, value, className = '' }) {
  return (
    <div
      className={`p-2 border ${className}`}
      style={{
        background: '#e8f5e9',
        borderColor: '#e6efe9',
        borderRadius: 6,
        minHeight: 58,
      }}
    >
      <div
        className="fw-bold text-uppercase"
        style={{ color: '#0f2f22', letterSpacing: '0.3px', fontSize: 12 }}
      >
        {label}:
      </div>
      <div style={{ color: '#0a1f17', fontSize: 14, lineHeight: 1.25 }}>{value}</div>
    </div>
  )
}

export default function UserData({ data, language = 'english' }) {
  const t = getTranslation(language)
  const isWaterReport = data.sampleType === 'WATER';

  return (
  <div className="container-fluid px-2 mt-2">

    {/* Row 1 */}
    <div className="row g-2">
      <div className="col-12 col-md-3">
        <Field label={t.name} value={data.name} />
      </div>
      <div className="col-12 col-md-3">
        <Field label={t.mobile} value={data.mobile} />
      </div>
      <div className="col-12 col-md-3">
        <Field label={t.address} value={data.address} />
      </div>
      <div className="col-12 col-md-3">
        <Field label={t.cityState} value={data.cityState} />
      </div>
    </div>

    {/* WATER REPORT VIEW */}
    {isWaterReport ? (
      <>
        {/* Row 2 */}
        <div className="row g-2 mt-1">
          <div className="col-12 col-md-3">
            <Field label={t.farmName} value={data.farmName} />
          </div>
          <div className="col-12 col-md-3">
            <Field label={t.sampleCode} value={data.sampleCode} />
          </div>
          <div className="col-12 col-md-3">
            <Field label={t.sampleType} value={data.sampleType} />
          </div>
        </div>
      </>
    ) : (
      <>
        {/* SOIL REPORT VIEW */}

        {/* Row 2 */}
        <div className="row g-2 mt-1">
          <div className="col-12 col-md-3">
            <Field label={t.previousCrop} value={data.previousCrop} />
          </div>
          <div className="col-12 col-md-3">
            <Field label={t.farmSize} value={data.farmSize} />
          </div>
          <div className="col-12 col-md-3">
            <Field label={t.farmName} value={data.farmName} />
          </div>
          <div className="col-12 col-md-3">
            <Field label={t.nextCrop} value={data.nextCrop} />
          </div>
        </div>

        {/* Row 3 */}
        <div className="row g-2 mt-1">
          <div className="col-12 col-md-3">
            <Field label={t.sampleCode} value={data.sampleCode} />
          </div>
          <div className="col-12 col-md-3">
            <Field label={t.sampleType} value={data.sampleType} />
          </div>
          <div className="col-12 col-md-3">
            <Field label={t.treatmentType} value={data.treatmentType} />
          </div>
          <div className="col-12 col-md-3">
            <Field label={t.reportDate} value={data.reportDate} />
          </div>
        </div>
      </>
    )}
  </div>
);
}
